import styled from 'styled-components';
import CloseButton from '../common/CloseButton';
import { useDispatch, useSelector } from 'react-redux';
import { MapMode } from '../../types';
import { useTranslation } from 'next-i18next';
import {
  setDrawerFirstOpened,
  setDrawerOpen,
  setMapMode,
  setSearchDrawerOpen,
  setSelectedCompound
} from '../../../../redux/slices/mapSlice';
import ThinArrowIcon from '../../../../new-components/svg-icons/ThinArrowIcon';
import { useRouter } from 'next/router';

interface DrawerHeaderProps {
  headerText?: string;
}

const DrawerHeader = ({ headerText }: DrawerHeaderProps) => {
  const { t } = useTranslation('map');
  const { locale } = useRouter();
  const dispatch = useDispatch();

  const isMobile = useSelector((state: any) => state.app.isMobile);

  const { mapMode, searchDrawerOpen } = useSelector((state: any) => state.map);

  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );
  const closeDrawer = () => {
    if (mapMode === MapMode.CalculateDistance) {
      dispatch(setDrawerOpen(false));
      dispatch(setMapMode(MapMode.SEARCH));
    }

    if (selectedCompound) {
      dispatch(setMapMode(MapMode.SEARCH));
      if (!searchDrawerOpen) {
        dispatch(setDrawerOpen(false));
      }
      dispatch(setSelectedCompound(null));
    }
  };

  return (
    <HeaderContainer>
      {!isMobile && mapMode == MapMode.SEARCH && (
        <SearchResultsCloseBtn
          onClick={() => {
            dispatch(setDrawerOpen(false));
            dispatch(setSearchDrawerOpen(false));
            dispatch(setDrawerFirstOpened(true))
          }}
        >
          <ThinArrowIcon
            stroke="#000"
            styles={{ transform: locale == 'ar' ? '' : 'rotate(180deg)' }}
          />
        </SearchResultsCloseBtn>
      )}
      <h2>{t(headerText ?? '')}</h2>

      {!isMobile && mapMode != MapMode.SEARCH && (
        <CloseButton handleClick={closeDrawer} />
      )}
    </HeaderContainer>
  );
};
const SearchResultsCloseBtn = styled.button`
  position: absolute;
  background-color: #fff;
  outline: none;
  border: none;
  top: 10px;
  inset-inline-start: -20px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;

const HeaderContainer = styled.div`
  z-index: 99;
  background: #fff;
  width: 100%;
  min-height: 40px;
  margin: 16px 0 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-size: 17px;
    font-family: materialBold;
    color: #2c3138;
  }

  .close-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #f0f1f3;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    position: unset;
    padding: 0;
  }
`;

export default DrawerHeader;
